import { TAppState } from "shared/redux/store";

export const selectPracticeState = (state: TAppState) => state.practice;